window.CLGSA_CONFIG = {
  "schemaVersion": 2,
  "mode": "live",
  "orderingEnabled": true,
  "priceSync": {
    "verified": true,
    "verifiedAt": "2026-10-06T01:00:58.326Z",
    "variants": [
      {
        "variantId": 51318386950311,
        "priceCents": 3099,
        "teamId": "diamond-divas",
        "productId": 11171891904679,
        "sku": "CLGSA-JMSV1-DIAMOND-DIVAS-Y2XS",
        "size": "Youth 2XS"
      },
      {
        "variantId": 51318386983079,
        "priceCents": 3099,
        "teamId": "diamond-divas",
        "productId": 11171891904679,
        "sku": "CLGSA-JMSV1-DIAMOND-DIVAS-YXS",
        "size": "Youth XS"
      },
      {
        "variantId": 51318387015847,
        "priceCents": 3099,
        "teamId": "diamond-divas",
        "productId": 11171891904679,
        "sku": "CLGSA-JMSV1-DIAMOND-DIVAS-YS",
        "size": "Youth S"
      },
      {
        "variantId": 51318387048615,
        "priceCents": 3099,
        "teamId": "diamond-divas",
        "productId": 11171891904679,
        "sku": "CLGSA-JMSV1-DIAMOND-DIVAS-YM",
        "size": "Youth M"
      },
      {
        "variantId": 51318387081383,
        "priceCents": 3099,
        "teamId": "diamond-divas",
        "productId": 11171891904679,
        "sku": "CLGSA-JMSV1-DIAMOND-DIVAS-YL",
        "size": "Youth L"
      },
      {
        "variantId": 51318387114151,
        "priceCents": 3099,
        "teamId": "diamond-divas",
        "productId": 11171891904679,
        "sku": "CLGSA-JMSV1-DIAMOND-DIVAS-YXL",
        "size": "Youth XL"
      },
      {
        "variantId": 51318387146919,
        "priceCents": 3199,
        "teamId": "diamond-divas",
        "productId": 11171891904679,
        "sku": "CLGSA-JMSV1-DIAMOND-DIVAS-AS",
        "size": "Adult S"
      },
      {
        "variantId": 51318387179687,
        "priceCents": 3199,
        "teamId": "diamond-divas",
        "productId": 11171891904679,
        "sku": "CLGSA-JMSV1-DIAMOND-DIVAS-AM",
        "size": "Adult M"
      },
      {
        "variantId": 51318387212455,
        "priceCents": 3199,
        "teamId": "diamond-divas",
        "productId": 11171891904679,
        "sku": "CLGSA-JMSV1-DIAMOND-DIVAS-AL",
        "size": "Adult L"
      },
      {
        "variantId": 51318387245223,
        "priceCents": 3199,
        "teamId": "diamond-divas",
        "productId": 11171891904679,
        "sku": "CLGSA-JMSV1-DIAMOND-DIVAS-AXL",
        "size": "Adult XL"
      },
      {
        "variantId": 51318387277991,
        "priceCents": 3499,
        "teamId": "diamond-divas",
        "productId": 11171891904679,
        "sku": "CLGSA-JMSV1-DIAMOND-DIVAS-A2XL",
        "size": "Adult 2XL"
      },
      {
        "variantId": 51318387310759,
        "priceCents": 3499,
        "teamId": "diamond-divas",
        "productId": 11171891904679,
        "sku": "CLGSA-JMSV1-DIAMOND-DIVAS-A3XL",
        "size": "Adult 3XL"
      },
      {
        "variantId": 51318387376295,
        "priceCents": 3099,
        "teamId": "suncatchers",
        "productId": 11171891970215,
        "sku": "CLGSA-JMSV1-SUNCATCHERS-Y2XS",
        "size": "Youth 2XS"
      },
      {
        "variantId": 51318387409063,
        "priceCents": 3099,
        "teamId": "suncatchers",
        "productId": 11171891970215,
        "sku": "CLGSA-JMSV1-SUNCATCHERS-YXS",
        "size": "Youth XS"
      },
      {
        "variantId": 51318387441831,
        "priceCents": 3099,
        "teamId": "suncatchers",
        "productId": 11171891970215,
        "sku": "CLGSA-JMSV1-SUNCATCHERS-YS",
        "size": "Youth S"
      },
      {
        "variantId": 51318387474599,
        "priceCents": 3099,
        "teamId": "suncatchers",
        "productId": 11171891970215,
        "sku": "CLGSA-JMSV1-SUNCATCHERS-YM",
        "size": "Youth M"
      },
      {
        "variantId": 51318387507367,
        "priceCents": 3099,
        "teamId": "suncatchers",
        "productId": 11171891970215,
        "sku": "CLGSA-JMSV1-SUNCATCHERS-YL",
        "size": "Youth L"
      },
      {
        "variantId": 51318387540135,
        "priceCents": 3099,
        "teamId": "suncatchers",
        "productId": 11171891970215,
        "sku": "CLGSA-JMSV1-SUNCATCHERS-YXL",
        "size": "Youth XL"
      },
      {
        "variantId": 51318387572903,
        "priceCents": 3199,
        "teamId": "suncatchers",
        "productId": 11171891970215,
        "sku": "CLGSA-JMSV1-SUNCATCHERS-AS",
        "size": "Adult S"
      },
      {
        "variantId": 51318387605671,
        "priceCents": 3199,
        "teamId": "suncatchers",
        "productId": 11171891970215,
        "sku": "CLGSA-JMSV1-SUNCATCHERS-AM",
        "size": "Adult M"
      },
      {
        "variantId": 51318387638439,
        "priceCents": 3199,
        "teamId": "suncatchers",
        "productId": 11171891970215,
        "sku": "CLGSA-JMSV1-SUNCATCHERS-AL",
        "size": "Adult L"
      },
      {
        "variantId": 51318387671207,
        "priceCents": 3199,
        "teamId": "suncatchers",
        "productId": 11171891970215,
        "sku": "CLGSA-JMSV1-SUNCATCHERS-AXL",
        "size": "Adult XL"
      },
      {
        "variantId": 51318387703975,
        "priceCents": 3499,
        "teamId": "suncatchers",
        "productId": 11171891970215,
        "sku": "CLGSA-JMSV1-SUNCATCHERS-A2XL",
        "size": "Adult 2XL"
      },
      {
        "variantId": 51318387736743,
        "priceCents": 3499,
        "teamId": "suncatchers",
        "productId": 11171891970215,
        "sku": "CLGSA-JMSV1-SUNCATCHERS-A3XL",
        "size": "Adult 3XL"
      },
      {
        "variantId": 51318387769511,
        "priceCents": 3099,
        "teamId": "valkyries",
        "productId": 11171892002983,
        "sku": "CLGSA-JMSV1-VALKYRIES-Y2XS",
        "size": "Youth 2XS"
      },
      {
        "variantId": 51318387802279,
        "priceCents": 3099,
        "teamId": "valkyries",
        "productId": 11171892002983,
        "sku": "CLGSA-JMSV1-VALKYRIES-YXS",
        "size": "Youth XS"
      },
      {
        "variantId": 51318387835047,
        "priceCents": 3099,
        "teamId": "valkyries",
        "productId": 11171892002983,
        "sku": "CLGSA-JMSV1-VALKYRIES-YS",
        "size": "Youth S"
      },
      {
        "variantId": 51318387867815,
        "priceCents": 3099,
        "teamId": "valkyries",
        "productId": 11171892002983,
        "sku": "CLGSA-JMSV1-VALKYRIES-YM",
        "size": "Youth M"
      },
      {
        "variantId": 51318387900583,
        "priceCents": 3099,
        "teamId": "valkyries",
        "productId": 11171892002983,
        "sku": "CLGSA-JMSV1-VALKYRIES-YL",
        "size": "Youth L"
      },
      {
        "variantId": 51318387933351,
        "priceCents": 3099,
        "teamId": "valkyries",
        "productId": 11171892002983,
        "sku": "CLGSA-JMSV1-VALKYRIES-YXL",
        "size": "Youth XL"
      },
      {
        "variantId": 51318387966119,
        "priceCents": 3199,
        "teamId": "valkyries",
        "productId": 11171892002983,
        "sku": "CLGSA-JMSV1-VALKYRIES-AS",
        "size": "Adult S"
      },
      {
        "variantId": 51318387998887,
        "priceCents": 3199,
        "teamId": "valkyries",
        "productId": 11171892002983,
        "sku": "CLGSA-JMSV1-VALKYRIES-AM",
        "size": "Adult M"
      },
      {
        "variantId": 51318388031655,
        "priceCents": 3199,
        "teamId": "valkyries",
        "productId": 11171892002983,
        "sku": "CLGSA-JMSV1-VALKYRIES-AL",
        "size": "Adult L"
      },
      {
        "variantId": 51318388064423,
        "priceCents": 3199,
        "teamId": "valkyries",
        "productId": 11171892002983,
        "sku": "CLGSA-JMSV1-VALKYRIES-AXL",
        "size": "Adult XL"
      },
      {
        "variantId": 51318388097191,
        "priceCents": 3499,
        "teamId": "valkyries",
        "productId": 11171892002983,
        "sku": "CLGSA-JMSV1-VALKYRIES-A2XL",
        "size": "Adult 2XL"
      },
      {
        "variantId": 51318388129959,
        "priceCents": 3499,
        "teamId": "valkyries",
        "productId": 11171892002983,
        "sku": "CLGSA-JMSV1-VALKYRIES-A3XL",
        "size": "Adult 3XL"
      },
      {
        "variantId": 51318388195495,
        "priceCents": 3099,
        "teamId": "thunderstruck",
        "productId": 11171892068519,
        "sku": "CLGSA-JMSV1-THUNDERSTRUCK-Y2XS",
        "size": "Youth 2XS"
      },
      {
        "variantId": 51318388228263,
        "priceCents": 3099,
        "teamId": "thunderstruck",
        "productId": 11171892068519,
        "sku": "CLGSA-JMSV1-THUNDERSTRUCK-YXS",
        "size": "Youth XS"
      },
      {
        "variantId": 51318388261031,
        "priceCents": 3099,
        "teamId": "thunderstruck",
        "productId": 11171892068519,
        "sku": "CLGSA-JMSV1-THUNDERSTRUCK-YS",
        "size": "Youth S"
      },
      {
        "variantId": 51318388293799,
        "priceCents": 3099,
        "teamId": "thunderstruck",
        "productId": 11171892068519,
        "sku": "CLGSA-JMSV1-THUNDERSTRUCK-YM",
        "size": "Youth M"
      },
      {
        "variantId": 51318388326567,
        "priceCents": 3099,
        "teamId": "thunderstruck",
        "productId": 11171892068519,
        "sku": "CLGSA-JMSV1-THUNDERSTRUCK-YL",
        "size": "Youth L"
      },
      {
        "variantId": 51318388359335,
        "priceCents": 3099,
        "teamId": "thunderstruck",
        "productId": 11171892068519,
        "sku": "CLGSA-JMSV1-THUNDERSTRUCK-YXL",
        "size": "Youth XL"
      },
      {
        "variantId": 51318388392103,
        "priceCents": 3199,
        "teamId": "thunderstruck",
        "productId": 11171892068519,
        "sku": "CLGSA-JMSV1-THUNDERSTRUCK-AS",
        "size": "Adult S"
      },
      {
        "variantId": 51318388424871,
        "priceCents": 3199,
        "teamId": "thunderstruck",
        "productId": 11171892068519,
        "sku": "CLGSA-JMSV1-THUNDERSTRUCK-AM",
        "size": "Adult M"
      },
      {
        "variantId": 51318388457639,
        "priceCents": 3199,
        "teamId": "thunderstruck",
        "productId": 11171892068519,
        "sku": "CLGSA-JMSV1-THUNDERSTRUCK-AL",
        "size": "Adult L"
      },
      {
        "variantId": 51318388490407,
        "priceCents": 3199,
        "teamId": "thunderstruck",
        "productId": 11171892068519,
        "sku": "CLGSA-JMSV1-THUNDERSTRUCK-AXL",
        "size": "Adult XL"
      },
      {
        "variantId": 51318388523175,
        "priceCents": 3499,
        "teamId": "thunderstruck",
        "productId": 11171892068519,
        "sku": "CLGSA-JMSV1-THUNDERSTRUCK-A2XL",
        "size": "Adult 2XL"
      },
      {
        "variantId": 51318388555943,
        "priceCents": 3499,
        "teamId": "thunderstruck",
        "productId": 11171892068519,
        "sku": "CLGSA-JMSV1-THUNDERSTRUCK-A3XL",
        "size": "Adult 3XL"
      },
      {
        "variantId": 51318388588711,
        "priceCents": 3099,
        "teamId": "sandlot-sisters",
        "productId": 11171892101287,
        "sku": "CLGSA-JMSV1-SANDLOT-SISTERS-Y2XS",
        "size": "Youth 2XS"
      },
      {
        "variantId": 51318388621479,
        "priceCents": 3099,
        "teamId": "sandlot-sisters",
        "productId": 11171892101287,
        "sku": "CLGSA-JMSV1-SANDLOT-SISTERS-YXS",
        "size": "Youth XS"
      },
      {
        "variantId": 51318388654247,
        "priceCents": 3099,
        "teamId": "sandlot-sisters",
        "productId": 11171892101287,
        "sku": "CLGSA-JMSV1-SANDLOT-SISTERS-YS",
        "size": "Youth S"
      },
      {
        "variantId": 51318388687015,
        "priceCents": 3099,
        "teamId": "sandlot-sisters",
        "productId": 11171892101287,
        "sku": "CLGSA-JMSV1-SANDLOT-SISTERS-YM",
        "size": "Youth M"
      },
      {
        "variantId": 51318388719783,
        "priceCents": 3099,
        "teamId": "sandlot-sisters",
        "productId": 11171892101287,
        "sku": "CLGSA-JMSV1-SANDLOT-SISTERS-YL",
        "size": "Youth L"
      },
      {
        "variantId": 51318388752551,
        "priceCents": 3099,
        "teamId": "sandlot-sisters",
        "productId": 11171892101287,
        "sku": "CLGSA-JMSV1-SANDLOT-SISTERS-YXL",
        "size": "Youth XL"
      },
      {
        "variantId": 51318388785319,
        "priceCents": 3199,
        "teamId": "sandlot-sisters",
        "productId": 11171892101287,
        "sku": "CLGSA-JMSV1-SANDLOT-SISTERS-AS",
        "size": "Adult S"
      },
      {
        "variantId": 51318388818087,
        "priceCents": 3199,
        "teamId": "sandlot-sisters",
        "productId": 11171892101287,
        "sku": "CLGSA-JMSV1-SANDLOT-SISTERS-AM",
        "size": "Adult M"
      },
      {
        "variantId": 51318388850855,
        "priceCents": 3199,
        "teamId": "sandlot-sisters",
        "productId": 11171892101287,
        "sku": "CLGSA-JMSV1-SANDLOT-SISTERS-AL",
        "size": "Adult L"
      },
      {
        "variantId": 51318388883623,
        "priceCents": 3199,
        "teamId": "sandlot-sisters",
        "productId": 11171892101287,
        "sku": "CLGSA-JMSV1-SANDLOT-SISTERS-AXL",
        "size": "Adult XL"
      },
      {
        "variantId": 51318388916391,
        "priceCents": 3499,
        "teamId": "sandlot-sisters",
        "productId": 11171892101287,
        "sku": "CLGSA-JMSV1-SANDLOT-SISTERS-A2XL",
        "size": "Adult 2XL"
      },
      {
        "variantId": 51318388949159,
        "priceCents": 3499,
        "teamId": "sandlot-sisters",
        "productId": 11171892101287,
        "sku": "CLGSA-JMSV1-SANDLOT-SISTERS-A3XL",
        "size": "Adult 3XL"
      },
      {
        "variantId": 51460010901671,
        "priceCents": 2599,
        "teamId": "player-diamond-divas",
        "productId": 11205603066023,
        "sku": "CLGSA-JSBJ2-DIAMOND-DIVAS-GS",
        "size": "Youth S"
      },
      {
        "variantId": 51462131056807,
        "priceCents": 2599,
        "teamId": "player-diamond-divas",
        "productId": 11205603066023,
        "sku": "CLGSA-JSBJ2-DIAMOND-DIVAS-GM",
        "size": "Youth M"
      },
      {
        "variantId": 51462131450023,
        "priceCents": 2599,
        "teamId": "player-diamond-divas",
        "productId": 11205603066023,
        "sku": "CLGSA-JSBJ2-DIAMOND-DIVAS-GL",
        "size": "Youth L"
      },
      {
        "variantId": 51462131744935,
        "priceCents": 2599,
        "teamId": "player-diamond-divas",
        "productId": 11205603066023,
        "sku": "CLGSA-JSBJ2-DIAMOND-DIVAS-GXL",
        "size": "Youth XL"
      },
      {
        "variantId": 51462131908775,
        "priceCents": 2699,
        "teamId": "player-diamond-divas",
        "productId": 11205603066023,
        "sku": "CLGSA-JSBJ2-DIAMOND-DIVAS-WXS",
        "size": "Adult XS"
      },
      {
        "variantId": 51462132793511,
        "priceCents": 2699,
        "teamId": "player-diamond-divas",
        "productId": 11205603066023,
        "sku": "CLGSA-JSBJ2-DIAMOND-DIVAS-WS",
        "size": "Adult S"
      },
      {
        "variantId": 51462132957351,
        "priceCents": 2699,
        "teamId": "player-diamond-divas",
        "productId": 11205603066023,
        "sku": "CLGSA-JSBJ2-DIAMOND-DIVAS-WM",
        "size": "Adult M"
      },
      {
        "variantId": 51462133285031,
        "priceCents": 2699,
        "teamId": "player-diamond-divas",
        "productId": 11205603066023,
        "sku": "CLGSA-JSBJ2-DIAMOND-DIVAS-WL",
        "size": "Adult L"
      },
      {
        "variantId": 51462133383335,
        "priceCents": 2699,
        "teamId": "player-diamond-divas",
        "productId": 11205603066023,
        "sku": "CLGSA-JSBJ2-DIAMOND-DIVAS-WXL",
        "size": "Adult XL"
      },
      {
        "variantId": 51462133547175,
        "priceCents": 2999,
        "teamId": "player-diamond-divas",
        "productId": 11205603066023,
        "sku": "CLGSA-JSBJ2-DIAMOND-DIVAS-W2XL",
        "size": "Adult 2XL"
      },
      {
        "variantId": 51462134005927,
        "priceCents": 2999,
        "teamId": "player-diamond-divas",
        "productId": 11205603066023,
        "sku": "CLGSA-JSBJ2-DIAMOND-DIVAS-W3XL",
        "size": "Adult 3XL"
      },
      {
        "variantId": 51460011851943,
        "priceCents": 2599,
        "teamId": "player-suncatchers",
        "productId": 11205603229863,
        "sku": "CLGSA-JSBJ2-SUNCATCHERS-GS",
        "size": "Youth S"
      },
      {
        "variantId": 51460011884711,
        "priceCents": 2599,
        "teamId": "player-suncatchers",
        "productId": 11205603229863,
        "sku": "CLGSA-JSBJ2-SUNCATCHERS-GM",
        "size": "Youth M"
      },
      {
        "variantId": 51460011917479,
        "priceCents": 2599,
        "teamId": "player-suncatchers",
        "productId": 11205603229863,
        "sku": "CLGSA-JSBJ2-SUNCATCHERS-GL",
        "size": "Youth L"
      },
      {
        "variantId": 51460011950247,
        "priceCents": 2599,
        "teamId": "player-suncatchers",
        "productId": 11205603229863,
        "sku": "CLGSA-JSBJ2-SUNCATCHERS-GXL",
        "size": "Youth XL"
      },
      {
        "variantId": 51460011983015,
        "priceCents": 2699,
        "teamId": "player-suncatchers",
        "productId": 11205603229863,
        "sku": "CLGSA-JSBJ2-SUNCATCHERS-WXS",
        "size": "Adult XS"
      },
      {
        "variantId": 51460012015783,
        "priceCents": 2699,
        "teamId": "player-suncatchers",
        "productId": 11205603229863,
        "sku": "CLGSA-JSBJ2-SUNCATCHERS-WS",
        "size": "Adult S"
      },
      {
        "variantId": 51460012048551,
        "priceCents": 2699,
        "teamId": "player-suncatchers",
        "productId": 11205603229863,
        "sku": "CLGSA-JSBJ2-SUNCATCHERS-WM",
        "size": "Adult M"
      },
      {
        "variantId": 51460012081319,
        "priceCents": 2699,
        "teamId": "player-suncatchers",
        "productId": 11205603229863,
        "sku": "CLGSA-JSBJ2-SUNCATCHERS-WL",
        "size": "Adult L"
      },
      {
        "variantId": 51460012114087,
        "priceCents": 2699,
        "teamId": "player-suncatchers",
        "productId": 11205603229863,
        "sku": "CLGSA-JSBJ2-SUNCATCHERS-WXL",
        "size": "Adult XL"
      },
      {
        "variantId": 51460012146855,
        "priceCents": 2999,
        "teamId": "player-suncatchers",
        "productId": 11205603229863,
        "sku": "CLGSA-JSBJ2-SUNCATCHERS-W2XL",
        "size": "Adult 2XL"
      },
      {
        "variantId": 51460012179623,
        "priceCents": 2999,
        "teamId": "player-suncatchers",
        "productId": 11205603229863,
        "sku": "CLGSA-JSBJ2-SUNCATCHERS-W3XL",
        "size": "Adult 3XL"
      },
      {
        "variantId": 51460012966055,
        "priceCents": 2599,
        "teamId": "player-thunderstruck",
        "productId": 11205603328167,
        "sku": "CLGSA-JSBJ2-THUNDERSTRUCK-GS",
        "size": "Youth S"
      },
      {
        "variantId": 51460012998823,
        "priceCents": 2599,
        "teamId": "player-thunderstruck",
        "productId": 11205603328167,
        "sku": "CLGSA-JSBJ2-THUNDERSTRUCK-GM",
        "size": "Youth M"
      },
      {
        "variantId": 51460013031591,
        "priceCents": 2599,
        "teamId": "player-thunderstruck",
        "productId": 11205603328167,
        "sku": "CLGSA-JSBJ2-THUNDERSTRUCK-GL",
        "size": "Youth L"
      },
      {
        "variantId": 51460013064359,
        "priceCents": 2599,
        "teamId": "player-thunderstruck",
        "productId": 11205603328167,
        "sku": "CLGSA-JSBJ2-THUNDERSTRUCK-GXL",
        "size": "Youth XL"
      },
      {
        "variantId": 51460013097127,
        "priceCents": 2699,
        "teamId": "player-thunderstruck",
        "productId": 11205603328167,
        "sku": "CLGSA-JSBJ2-THUNDERSTRUCK-WXS",
        "size": "Adult XS"
      },
      {
        "variantId": 51460013129895,
        "priceCents": 2699,
        "teamId": "player-thunderstruck",
        "productId": 11205603328167,
        "sku": "CLGSA-JSBJ2-THUNDERSTRUCK-WS",
        "size": "Adult S"
      },
      {
        "variantId": 51460013162663,
        "priceCents": 2699,
        "teamId": "player-thunderstruck",
        "productId": 11205603328167,
        "sku": "CLGSA-JSBJ2-THUNDERSTRUCK-WM",
        "size": "Adult M"
      },
      {
        "variantId": 51460013195431,
        "priceCents": 2699,
        "teamId": "player-thunderstruck",
        "productId": 11205603328167,
        "sku": "CLGSA-JSBJ2-THUNDERSTRUCK-WL",
        "size": "Adult L"
      },
      {
        "variantId": 51460013228199,
        "priceCents": 2699,
        "teamId": "player-thunderstruck",
        "productId": 11205603328167,
        "sku": "CLGSA-JSBJ2-THUNDERSTRUCK-WXL",
        "size": "Adult XL"
      },
      {
        "variantId": 51460013260967,
        "priceCents": 2999,
        "teamId": "player-thunderstruck",
        "productId": 11205603328167,
        "sku": "CLGSA-JSBJ2-THUNDERSTRUCK-W2XL",
        "size": "Adult 2XL"
      },
      {
        "variantId": 51460013293735,
        "priceCents": 2999,
        "teamId": "player-thunderstruck",
        "productId": 11205603328167,
        "sku": "CLGSA-JSBJ2-THUNDERSTRUCK-W3XL",
        "size": "Adult 3XL"
      },
      {
        "variantId": 51460014047399,
        "priceCents": 2599,
        "teamId": "player-sandlot-sisters",
        "productId": 11205603459239,
        "sku": "CLGSA-JSBJ2-SANDLOT-SISTERS-GS",
        "size": "Youth S"
      },
      {
        "variantId": 51460014080167,
        "priceCents": 2599,
        "teamId": "player-sandlot-sisters",
        "productId": 11205603459239,
        "sku": "CLGSA-JSBJ2-SANDLOT-SISTERS-GM",
        "size": "Youth M"
      },
      {
        "variantId": 51460014112935,
        "priceCents": 2599,
        "teamId": "player-sandlot-sisters",
        "productId": 11205603459239,
        "sku": "CLGSA-JSBJ2-SANDLOT-SISTERS-GL",
        "size": "Youth L"
      },
      {
        "variantId": 51460014145703,
        "priceCents": 2599,
        "teamId": "player-sandlot-sisters",
        "productId": 11205603459239,
        "sku": "CLGSA-JSBJ2-SANDLOT-SISTERS-GXL",
        "size": "Youth XL"
      },
      {
        "variantId": 51460014178471,
        "priceCents": 2699,
        "teamId": "player-sandlot-sisters",
        "productId": 11205603459239,
        "sku": "CLGSA-JSBJ2-SANDLOT-SISTERS-WXS",
        "size": "Adult XS"
      },
      {
        "variantId": 51460014211239,
        "priceCents": 2699,
        "teamId": "player-sandlot-sisters",
        "productId": 11205603459239,
        "sku": "CLGSA-JSBJ2-SANDLOT-SISTERS-WS",
        "size": "Adult S"
      },
      {
        "variantId": 51460014244007,
        "priceCents": 2699,
        "teamId": "player-sandlot-sisters",
        "productId": 11205603459239,
        "sku": "CLGSA-JSBJ2-SANDLOT-SISTERS-WM",
        "size": "Adult M"
      },
      {
        "variantId": 51460014276775,
        "priceCents": 2699,
        "teamId": "player-sandlot-sisters",
        "productId": 11205603459239,
        "sku": "CLGSA-JSBJ2-SANDLOT-SISTERS-WL",
        "size": "Adult L"
      },
      {
        "variantId": 51460014309543,
        "priceCents": 2699,
        "teamId": "player-sandlot-sisters",
        "productId": 11205603459239,
        "sku": "CLGSA-JSBJ2-SANDLOT-SISTERS-WXL",
        "size": "Adult XL"
      },
      {
        "variantId": 51460014342311,
        "priceCents": 2999,
        "teamId": "player-sandlot-sisters",
        "productId": 11205603459239,
        "sku": "CLGSA-JSBJ2-SANDLOT-SISTERS-W2XL",
        "size": "Adult 2XL"
      },
      {
        "variantId": 51460014375079,
        "priceCents": 2999,
        "teamId": "player-sandlot-sisters",
        "productId": 11205603459239,
        "sku": "CLGSA-JSBJ2-SANDLOT-SISTERS-W3XL",
        "size": "Adult 3XL"
      },
      {
        "variantId": 51460015030439,
        "priceCents": 2599,
        "teamId": "player-valkyries",
        "productId": 11205603557543,
        "sku": "CLGSA-JSBJ2-VALKYRIES-GS",
        "size": "Youth S"
      },
      {
        "variantId": 51460015063207,
        "priceCents": 2599,
        "teamId": "player-valkyries",
        "productId": 11205603557543,
        "sku": "CLGSA-JSBJ2-VALKYRIES-GM",
        "size": "Youth M"
      },
      {
        "variantId": 51460015095975,
        "priceCents": 2599,
        "teamId": "player-valkyries",
        "productId": 11205603557543,
        "sku": "CLGSA-JSBJ2-VALKYRIES-GL",
        "size": "Youth L"
      },
      {
        "variantId": 51460015128743,
        "priceCents": 2599,
        "teamId": "player-valkyries",
        "productId": 11205603557543,
        "sku": "CLGSA-JSBJ2-VALKYRIES-GXL",
        "size": "Youth XL"
      },
      {
        "variantId": 51460015161511,
        "priceCents": 2699,
        "teamId": "player-valkyries",
        "productId": 11205603557543,
        "sku": "CLGSA-JSBJ2-VALKYRIES-WXS",
        "size": "Adult XS"
      },
      {
        "variantId": 51460015194279,
        "priceCents": 2699,
        "teamId": "player-valkyries",
        "productId": 11205603557543,
        "sku": "CLGSA-JSBJ2-VALKYRIES-WS",
        "size": "Adult S"
      },
      {
        "variantId": 51460015227047,
        "priceCents": 2699,
        "teamId": "player-valkyries",
        "productId": 11205603557543,
        "sku": "CLGSA-JSBJ2-VALKYRIES-WM",
        "size": "Adult M"
      },
      {
        "variantId": 51460015259815,
        "priceCents": 2699,
        "teamId": "player-valkyries",
        "productId": 11205603557543,
        "sku": "CLGSA-JSBJ2-VALKYRIES-WL",
        "size": "Adult L"
      },
      {
        "variantId": 51460015292583,
        "priceCents": 2699,
        "teamId": "player-valkyries",
        "productId": 11205603557543,
        "sku": "CLGSA-JSBJ2-VALKYRIES-WXL",
        "size": "Adult XL"
      },
      {
        "variantId": 51460015325351,
        "priceCents": 2999,
        "teamId": "player-valkyries",
        "productId": 11205603557543,
        "sku": "CLGSA-JSBJ2-VALKYRIES-W2XL",
        "size": "Adult 2XL"
      },
      {
        "variantId": 51460015358119,
        "priceCents": 2999,
        "teamId": "player-valkyries",
        "productId": 11205603557543,
        "sku": "CLGSA-JSBJ2-VALKYRIES-W3XL",
        "size": "Adult 3XL"
      }
    ]
  },
  "league": "Canyon Lake Girls Softball",
  "sku": "JMSV1",
  "currency": "USD",
  "tiers": [
    {
      "id": "youth",
      "label": "Youth",
      "priceCents": 3099
    },
    {
      "id": "adult",
      "label": "Adult",
      "priceCents": 3199
    },
    {
      "id": "adult-plus",
      "label": "Adult 2XL+",
      "priceCents": 3499
    }
  ],
  "fulfillment": {
    "approved": true,
    "mode": "team-coach-distribution",
    "customerText": "Jerseys will go to the league/coaches for team handout—not parent pickup at PIAS or home shipping. Handout timing is not yet announced.",
    "checkoutLabelsVerified": true,
    "notificationsVerified": false
  },
  "orderingWindow": {
    "approved": true,
    "batchId": "clgsa-20261003",
    "timeZone": "America/Chicago",
    "opensAt": "2026-10-06T01:00:58.326Z",
    "closesAt": null,
    "sourceMessage": "53389",
    "bindingRule": "owner-open-ended"
  },
  "policies": {
    "approved": true,
    "customerText": "No returns on customized items."
  },
  "sizeGuide": {
    "approved": true,
    "customerText": "Manufacturer BODY measurements in inches — not finished garment measurements. No fit conversion is implied.",
    "sourceUrl": "https://shop.champrosports.com/product/584/juice-v-neck-short-sleeve-t-shirt-adult-youth",
    "smallestYouthCaveat": "Youth 2XS is offered for JMSV1, but the manufacturer labels its smallest youth measurement row “XSS”. Confirm that mapping with the supplier before relying on it for Youth 2XS fit.",
    "bodyMeasurements": {
      "youth-2xs": null,
      "youth-xs": {
        "chest": "24–26",
        "waist": "21–23"
      },
      "youth-s": {
        "chest": "26–28",
        "waist": "23–25"
      },
      "youth-m": {
        "chest": "28–30",
        "waist": "25–27"
      },
      "youth-l": {
        "chest": "30–32",
        "waist": "27–29"
      },
      "youth-xl": {
        "chest": "32–34",
        "waist": "29–31"
      },
      "adult-s": {
        "chest": "34–36",
        "waist": "28–30"
      },
      "adult-m": {
        "chest": "38–40",
        "waist": "32–34"
      },
      "adult-l": {
        "chest": "42–44",
        "waist": "36–38"
      },
      "adult-xl": {
        "chest": "46–48",
        "waist": "40–42"
      },
      "adult-2xl": {
        "chest": "50–52",
        "waist": "44–46"
      },
      "adult-3xl": {
        "chest": "54–56",
        "waist": "48–50"
      }
    }
  },
  "shopify": {
    "origin": "https://hillcountrystandard.com",
    "root": "/"
  },
  "teams": [
    {
      "id": "diamond-divas",
      "name": "Diamond Divas",
      "accent": "#b12669",
      "tagline": "A little sparkle. A lot of game.",
      "images": {
        "front": "assets/diamond-divas-front.jpg",
        "back": "assets/diamond-divas-back.jpg"
      },
      "sizes": [
        {
          "id": "youth-2xs",
          "label": "Youth 2XS",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318386950311,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-DIAMOND-DIVAS-Y2XS",
          "priceCents": 3099
        },
        {
          "id": "youth-xs",
          "label": "Youth XS",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318386983079,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-DIAMOND-DIVAS-YXS",
          "priceCents": 3099
        },
        {
          "id": "youth-s",
          "label": "Youth S",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318387015847,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-DIAMOND-DIVAS-YS",
          "priceCents": 3099
        },
        {
          "id": "youth-m",
          "label": "Youth M",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318387048615,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-DIAMOND-DIVAS-YM",
          "priceCents": 3099
        },
        {
          "id": "youth-l",
          "label": "Youth L",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318387081383,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-DIAMOND-DIVAS-YL",
          "priceCents": 3099
        },
        {
          "id": "youth-xl",
          "label": "Youth XL",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318387114151,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-DIAMOND-DIVAS-YXL",
          "priceCents": 3099
        },
        {
          "id": "adult-s",
          "label": "Adult S",
          "tierId": "adult",
          "supplierSizeConfirmed": true,
          "variantId": 51318387146919,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-DIAMOND-DIVAS-AS",
          "priceCents": 3199
        },
        {
          "id": "adult-m",
          "label": "Adult M",
          "tierId": "adult",
          "supplierSizeConfirmed": true,
          "variantId": 51318387179687,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-DIAMOND-DIVAS-AM",
          "priceCents": 3199
        },
        {
          "id": "adult-l",
          "label": "Adult L",
          "tierId": "adult",
          "supplierSizeConfirmed": true,
          "variantId": 51318387212455,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-DIAMOND-DIVAS-AL",
          "priceCents": 3199
        },
        {
          "id": "adult-xl",
          "label": "Adult XL",
          "tierId": "adult",
          "supplierSizeConfirmed": true,
          "variantId": 51318387245223,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-DIAMOND-DIVAS-AXL",
          "priceCents": 3199
        },
        {
          "id": "adult-2xl",
          "label": "Adult 2XL",
          "tierId": "adult-plus",
          "supplierSizeConfirmed": true,
          "variantId": 51318387277991,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-DIAMOND-DIVAS-A2XL",
          "priceCents": 3499
        },
        {
          "id": "adult-3xl",
          "label": "Adult 3XL",
          "tierId": "adult-plus",
          "supplierSizeConfirmed": true,
          "variantId": 51318387310759,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-DIAMOND-DIVAS-A3XL",
          "priceCents": 3499
        }
      ],
      "personalization": {
        "mode": "optional-name-number",
        "ownerConfirmed": true,
        "rulesConfirmed": true,
        "supplierLimitsVerified": false,
        "fields": [
          {
            "id": "name",
            "label": "Name",
            "property": "Player Name",
            "maxLength": null,
            "format": "text"
          },
          {
            "id": "number",
            "label": "Number",
            "property": "Player Number",
            "maxLength": null,
            "format": "digits"
          }
        ],
        "confirmationText": "I confirm my back choice and any entered spelling, capitalization and number. Anything I left off must not be added.",
        "formatsVerified": false
      },
      "approvedArtwork": true,
      "shopifyProduct": {
        "id": 11171891904679,
        "status": "UNLISTED",
        "salesChannels": 1,
        "mediaCount": 2,
        "handle": "clgsa-diamond-divas-jmsv1"
      }
    },
    {
      "id": "suncatchers",
      "name": "Suncatchers",
      "accent": "#a45100",
      "tagline": "Bring the sunshine to the sidelines.",
      "images": {
        "front": "assets/suncatchers-front.jpg",
        "back": "assets/suncatchers-back.jpg"
      },
      "sizes": [
        {
          "id": "youth-2xs",
          "label": "Youth 2XS",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318387376295,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-SUNCATCHERS-Y2XS",
          "priceCents": 3099
        },
        {
          "id": "youth-xs",
          "label": "Youth XS",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318387409063,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-SUNCATCHERS-YXS",
          "priceCents": 3099
        },
        {
          "id": "youth-s",
          "label": "Youth S",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318387441831,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-SUNCATCHERS-YS",
          "priceCents": 3099
        },
        {
          "id": "youth-m",
          "label": "Youth M",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318387474599,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-SUNCATCHERS-YM",
          "priceCents": 3099
        },
        {
          "id": "youth-l",
          "label": "Youth L",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318387507367,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-SUNCATCHERS-YL",
          "priceCents": 3099
        },
        {
          "id": "youth-xl",
          "label": "Youth XL",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318387540135,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-SUNCATCHERS-YXL",
          "priceCents": 3099
        },
        {
          "id": "adult-s",
          "label": "Adult S",
          "tierId": "adult",
          "supplierSizeConfirmed": true,
          "variantId": 51318387572903,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-SUNCATCHERS-AS",
          "priceCents": 3199
        },
        {
          "id": "adult-m",
          "label": "Adult M",
          "tierId": "adult",
          "supplierSizeConfirmed": true,
          "variantId": 51318387605671,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-SUNCATCHERS-AM",
          "priceCents": 3199
        },
        {
          "id": "adult-l",
          "label": "Adult L",
          "tierId": "adult",
          "supplierSizeConfirmed": true,
          "variantId": 51318387638439,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-SUNCATCHERS-AL",
          "priceCents": 3199
        },
        {
          "id": "adult-xl",
          "label": "Adult XL",
          "tierId": "adult",
          "supplierSizeConfirmed": true,
          "variantId": 51318387671207,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-SUNCATCHERS-AXL",
          "priceCents": 3199
        },
        {
          "id": "adult-2xl",
          "label": "Adult 2XL",
          "tierId": "adult-plus",
          "supplierSizeConfirmed": true,
          "variantId": 51318387703975,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-SUNCATCHERS-A2XL",
          "priceCents": 3499
        },
        {
          "id": "adult-3xl",
          "label": "Adult 3XL",
          "tierId": "adult-plus",
          "supplierSizeConfirmed": true,
          "variantId": 51318387736743,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-SUNCATCHERS-A3XL",
          "priceCents": 3499
        }
      ],
      "personalization": {
        "mode": "optional-name-number",
        "ownerConfirmed": true,
        "rulesConfirmed": true,
        "supplierLimitsVerified": false,
        "fields": [
          {
            "id": "name",
            "label": "Name",
            "property": "Player Name",
            "maxLength": null,
            "format": "text"
          },
          {
            "id": "number",
            "label": "Number",
            "property": "Player Number",
            "maxLength": null,
            "format": "digits"
          }
        ],
        "confirmationText": "I confirm my back choice and any entered spelling, capitalization and number. Anything I left off must not be added.",
        "formatsVerified": false
      },
      "approvedArtwork": true,
      "shopifyProduct": {
        "id": 11171891970215,
        "status": "UNLISTED",
        "salesChannels": 1,
        "mediaCount": 2,
        "handle": "clgsa-suncatchers-jmsv1"
      }
    },
    {
      "id": "valkyries",
      "name": "Valkyries",
      "accent": "#34758b",
      "tagline": "Show up strong. Stand together.",
      "images": {
        "front": "assets/valkyries-front.jpg",
        "back": "assets/valkyries-back.jpg"
      },
      "sizes": [
        {
          "id": "youth-2xs",
          "label": "Youth 2XS",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318387769511,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-VALKYRIES-Y2XS",
          "priceCents": 3099
        },
        {
          "id": "youth-xs",
          "label": "Youth XS",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318387802279,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-VALKYRIES-YXS",
          "priceCents": 3099
        },
        {
          "id": "youth-s",
          "label": "Youth S",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318387835047,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-VALKYRIES-YS",
          "priceCents": 3099
        },
        {
          "id": "youth-m",
          "label": "Youth M",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318387867815,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-VALKYRIES-YM",
          "priceCents": 3099
        },
        {
          "id": "youth-l",
          "label": "Youth L",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318387900583,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-VALKYRIES-YL",
          "priceCents": 3099
        },
        {
          "id": "youth-xl",
          "label": "Youth XL",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318387933351,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-VALKYRIES-YXL",
          "priceCents": 3099
        },
        {
          "id": "adult-s",
          "label": "Adult S",
          "tierId": "adult",
          "supplierSizeConfirmed": true,
          "variantId": 51318387966119,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-VALKYRIES-AS",
          "priceCents": 3199
        },
        {
          "id": "adult-m",
          "label": "Adult M",
          "tierId": "adult",
          "supplierSizeConfirmed": true,
          "variantId": 51318387998887,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-VALKYRIES-AM",
          "priceCents": 3199
        },
        {
          "id": "adult-l",
          "label": "Adult L",
          "tierId": "adult",
          "supplierSizeConfirmed": true,
          "variantId": 51318388031655,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-VALKYRIES-AL",
          "priceCents": 3199
        },
        {
          "id": "adult-xl",
          "label": "Adult XL",
          "tierId": "adult",
          "supplierSizeConfirmed": true,
          "variantId": 51318388064423,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-VALKYRIES-AXL",
          "priceCents": 3199
        },
        {
          "id": "adult-2xl",
          "label": "Adult 2XL",
          "tierId": "adult-plus",
          "supplierSizeConfirmed": true,
          "variantId": 51318388097191,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-VALKYRIES-A2XL",
          "priceCents": 3499
        },
        {
          "id": "adult-3xl",
          "label": "Adult 3XL",
          "tierId": "adult-plus",
          "supplierSizeConfirmed": true,
          "variantId": 51318388129959,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-VALKYRIES-A3XL",
          "priceCents": 3499
        }
      ],
      "personalization": {
        "mode": "optional-name-number",
        "ownerConfirmed": true,
        "rulesConfirmed": true,
        "supplierLimitsVerified": false,
        "fields": [
          {
            "id": "name",
            "label": "Name",
            "property": "Player Name",
            "maxLength": null,
            "format": "text"
          },
          {
            "id": "number",
            "label": "Number",
            "property": "Player Number",
            "maxLength": null,
            "format": "digits"
          }
        ],
        "confirmationText": "I confirm my back choice and any entered spelling, capitalization and number. Anything I left off must not be added.",
        "formatsVerified": false
      },
      "approvedArtwork": true,
      "shopifyProduct": {
        "id": 11171892002983,
        "status": "UNLISTED",
        "salesChannels": 1,
        "mediaCount": 2,
        "handle": "clgsa-valkyries-jmsv1"
      }
    },
    {
      "id": "thunderstruck",
      "name": "Thunderstruck",
      "accent": "#5b418e",
      "tagline": "Make some noise for your team.",
      "images": {
        "front": "assets/thunderstruck-front.jpg",
        "back": "assets/thunderstruck-back.jpg"
      },
      "sizes": [
        {
          "id": "youth-2xs",
          "label": "Youth 2XS",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318388195495,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-THUNDERSTRUCK-Y2XS",
          "priceCents": 3099
        },
        {
          "id": "youth-xs",
          "label": "Youth XS",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318388228263,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-THUNDERSTRUCK-YXS",
          "priceCents": 3099
        },
        {
          "id": "youth-s",
          "label": "Youth S",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318388261031,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-THUNDERSTRUCK-YS",
          "priceCents": 3099
        },
        {
          "id": "youth-m",
          "label": "Youth M",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318388293799,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-THUNDERSTRUCK-YM",
          "priceCents": 3099
        },
        {
          "id": "youth-l",
          "label": "Youth L",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318388326567,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-THUNDERSTRUCK-YL",
          "priceCents": 3099
        },
        {
          "id": "youth-xl",
          "label": "Youth XL",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318388359335,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-THUNDERSTRUCK-YXL",
          "priceCents": 3099
        },
        {
          "id": "adult-s",
          "label": "Adult S",
          "tierId": "adult",
          "supplierSizeConfirmed": true,
          "variantId": 51318388392103,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-THUNDERSTRUCK-AS",
          "priceCents": 3199
        },
        {
          "id": "adult-m",
          "label": "Adult M",
          "tierId": "adult",
          "supplierSizeConfirmed": true,
          "variantId": 51318388424871,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-THUNDERSTRUCK-AM",
          "priceCents": 3199
        },
        {
          "id": "adult-l",
          "label": "Adult L",
          "tierId": "adult",
          "supplierSizeConfirmed": true,
          "variantId": 51318388457639,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-THUNDERSTRUCK-AL",
          "priceCents": 3199
        },
        {
          "id": "adult-xl",
          "label": "Adult XL",
          "tierId": "adult",
          "supplierSizeConfirmed": true,
          "variantId": 51318388490407,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-THUNDERSTRUCK-AXL",
          "priceCents": 3199
        },
        {
          "id": "adult-2xl",
          "label": "Adult 2XL",
          "tierId": "adult-plus",
          "supplierSizeConfirmed": true,
          "variantId": 51318388523175,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-THUNDERSTRUCK-A2XL",
          "priceCents": 3499
        },
        {
          "id": "adult-3xl",
          "label": "Adult 3XL",
          "tierId": "adult-plus",
          "supplierSizeConfirmed": true,
          "variantId": 51318388555943,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-THUNDERSTRUCK-A3XL",
          "priceCents": 3499
        }
      ],
      "personalization": {
        "mode": "optional-name-number",
        "ownerConfirmed": true,
        "rulesConfirmed": true,
        "supplierLimitsVerified": false,
        "fields": [
          {
            "id": "name",
            "label": "Name",
            "property": "Player Name",
            "maxLength": null,
            "format": "text"
          },
          {
            "id": "number",
            "label": "Number",
            "property": "Player Number",
            "maxLength": null,
            "format": "digits"
          }
        ],
        "confirmationText": "I confirm my back choice and any entered spelling, capitalization and number. Anything I left off must not be added.",
        "formatsVerified": false
      },
      "approvedArtwork": true,
      "shopifyProduct": {
        "id": 11171892068519,
        "status": "UNLISTED",
        "salesChannels": 1,
        "mediaCount": 2,
        "handle": "clgsa-thunderstruck-jmsv1"
      }
    },
    {
      "id": "sandlot-sisters",
      "name": "Sandlot Sisters",
      "accent": "#a62059",
      "tagline": "Same team. Same heart.",
      "images": {
        "front": "assets/sandlot-sisters-front.jpg",
        "back": "assets/sandlot-sisters-back.jpg"
      },
      "sizes": [
        {
          "id": "youth-2xs",
          "label": "Youth 2XS",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318388588711,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-SANDLOT-SISTERS-Y2XS",
          "priceCents": 3099
        },
        {
          "id": "youth-xs",
          "label": "Youth XS",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318388621479,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-SANDLOT-SISTERS-YXS",
          "priceCents": 3099
        },
        {
          "id": "youth-s",
          "label": "Youth S",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318388654247,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-SANDLOT-SISTERS-YS",
          "priceCents": 3099
        },
        {
          "id": "youth-m",
          "label": "Youth M",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318388687015,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-SANDLOT-SISTERS-YM",
          "priceCents": 3099
        },
        {
          "id": "youth-l",
          "label": "Youth L",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318388719783,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-SANDLOT-SISTERS-YL",
          "priceCents": 3099
        },
        {
          "id": "youth-xl",
          "label": "Youth XL",
          "tierId": "youth",
          "supplierSizeConfirmed": true,
          "variantId": 51318388752551,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-SANDLOT-SISTERS-YXL",
          "priceCents": 3099
        },
        {
          "id": "adult-s",
          "label": "Adult S",
          "tierId": "adult",
          "supplierSizeConfirmed": true,
          "variantId": 51318388785319,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-SANDLOT-SISTERS-AS",
          "priceCents": 3199
        },
        {
          "id": "adult-m",
          "label": "Adult M",
          "tierId": "adult",
          "supplierSizeConfirmed": true,
          "variantId": 51318388818087,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-SANDLOT-SISTERS-AM",
          "priceCents": 3199
        },
        {
          "id": "adult-l",
          "label": "Adult L",
          "tierId": "adult",
          "supplierSizeConfirmed": true,
          "variantId": 51318388850855,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-SANDLOT-SISTERS-AL",
          "priceCents": 3199
        },
        {
          "id": "adult-xl",
          "label": "Adult XL",
          "tierId": "adult",
          "supplierSizeConfirmed": true,
          "variantId": 51318388883623,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-SANDLOT-SISTERS-AXL",
          "priceCents": 3199
        },
        {
          "id": "adult-2xl",
          "label": "Adult 2XL",
          "tierId": "adult-plus",
          "supplierSizeConfirmed": true,
          "variantId": 51318388916391,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-SANDLOT-SISTERS-A2XL",
          "priceCents": 3499
        },
        {
          "id": "adult-3xl",
          "label": "Adult 3XL",
          "tierId": "adult-plus",
          "supplierSizeConfirmed": true,
          "variantId": 51318388949159,
          "verified": true,
          "available": true,
          "sku": "CLGSA-JMSV1-SANDLOT-SISTERS-A3XL",
          "priceCents": 3499
        }
      ],
      "personalization": {
        "mode": "optional-name-number",
        "ownerConfirmed": true,
        "rulesConfirmed": true,
        "supplierLimitsVerified": false,
        "fields": [
          {
            "id": "name",
            "label": "Name",
            "property": "Player Name",
            "maxLength": null,
            "format": "text"
          },
          {
            "id": "number",
            "label": "Number",
            "property": "Player Number",
            "maxLength": null,
            "format": "digits"
          }
        ],
        "confirmationText": "I confirm my back choice and any entered spelling, capitalization and number. Anything I left off must not be added.",
        "formatsVerified": false
      },
      "approvedArtwork": true,
      "shopifyProduct": {
        "id": 11171892101287,
        "status": "UNLISTED",
        "salesChannels": 1,
        "mediaCount": 2,
        "handle": "clgsa-sandlot-sisters-jmsv1"
      }
    },
    {
      "id": "player-diamond-divas",
      "name": "Diamond Divas 10U Player",
      "model": "JSBJ2",
      "accent": "#b12669",
      "tagline": "Black · Power Stretch (proof specification; current availability unverified)",
      "images": {
        "front": "assets/player-diamond-divas.png"
      },
      "sizes": [
        {
          "id": "youth-s",
          "label": "Youth S",
          "displayLabel": "Girls S",
          "tierId": "youth",
          "sku": "CLGSA-JSBJ2-DIAMOND-DIVAS-GS",
          "priceCents": 2599,
          "variantId": 51460010901671,
          "verified": true,
          "available": true
        },
        {
          "id": "youth-m",
          "label": "Youth M",
          "displayLabel": "Girls M",
          "tierId": "youth",
          "sku": "CLGSA-JSBJ2-DIAMOND-DIVAS-GM",
          "priceCents": 2599,
          "variantId": 51462131056807,
          "verified": true,
          "available": true
        },
        {
          "id": "youth-l",
          "label": "Youth L",
          "displayLabel": "Girls L",
          "tierId": "youth",
          "sku": "CLGSA-JSBJ2-DIAMOND-DIVAS-GL",
          "priceCents": 2599,
          "variantId": 51462131450023,
          "verified": true,
          "available": true
        },
        {
          "id": "youth-xl",
          "label": "Youth XL",
          "displayLabel": "Girls XL",
          "tierId": "youth",
          "sku": "CLGSA-JSBJ2-DIAMOND-DIVAS-GXL",
          "priceCents": 2599,
          "variantId": 51462131744935,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-xs",
          "label": "Adult XS",
          "displayLabel": "Women XS",
          "tierId": "adult",
          "sku": "CLGSA-JSBJ2-DIAMOND-DIVAS-WXS",
          "priceCents": 2699,
          "variantId": 51462131908775,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-s",
          "label": "Adult S",
          "displayLabel": "Women S",
          "tierId": "adult",
          "sku": "CLGSA-JSBJ2-DIAMOND-DIVAS-WS",
          "priceCents": 2699,
          "variantId": 51462132793511,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-m",
          "label": "Adult M",
          "displayLabel": "Women M",
          "tierId": "adult",
          "sku": "CLGSA-JSBJ2-DIAMOND-DIVAS-WM",
          "priceCents": 2699,
          "variantId": 51462132957351,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-l",
          "label": "Adult L",
          "displayLabel": "Women L",
          "tierId": "adult",
          "sku": "CLGSA-JSBJ2-DIAMOND-DIVAS-WL",
          "priceCents": 2699,
          "variantId": 51462133285031,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-xl",
          "label": "Adult XL",
          "displayLabel": "Women XL",
          "tierId": "adult",
          "sku": "CLGSA-JSBJ2-DIAMOND-DIVAS-WXL",
          "priceCents": 2699,
          "variantId": 51462133383335,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-2xl",
          "label": "Adult 2XL",
          "displayLabel": "Women 2XL",
          "tierId": "adult-plus",
          "sku": "CLGSA-JSBJ2-DIAMOND-DIVAS-W2XL",
          "priceCents": 2999,
          "variantId": 51462133547175,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-3xl",
          "label": "Adult 3XL",
          "displayLabel": "Women 3XL",
          "tierId": "adult-plus",
          "sku": "CLGSA-JSBJ2-DIAMOND-DIVAS-W3XL",
          "priceCents": 2999,
          "variantId": 51462134005927,
          "verified": true,
          "available": true
        }
      ],
      "personalization": {
        "mode": "optional-name-number",
        "rulesConfirmed": true,
        "supplierLimitsVerified": false,
        "formatsVerified": false,
        "fields": [
          {
            "id": "name",
            "label": "Name",
            "property": "Player Name",
            "maxLength": null,
            "format": "text"
          },
          {
            "id": "number",
            "label": "Number",
            "property": "Player Number",
            "maxLength": null,
            "format": "digits"
          }
        ],
        "confirmationText": "I confirm my back choice, spelling, capitalization and number. Anything omitted must not be added."
      },
      "approvedArtwork": true,
      "shopifyProduct": {
        "id": 11205603066023,
        "handle": "clgsa-player-diamond-divas-jsbj2",
        "status": "DRAFT",
        "salesChannels": 0,
        "mediaCount": 1
      }
    },
    {
      "id": "player-suncatchers",
      "name": "Suncatchers 8U Player",
      "model": "JSBJ2",
      "accent": "#a45100",
      "tagline": "Gold · C-TEC (proof specification; current availability unverified)",
      "images": {
        "front": "assets/player-suncatchers.png"
      },
      "sizes": [
        {
          "id": "youth-s",
          "label": "Youth S",
          "displayLabel": "Girls S",
          "tierId": "youth",
          "sku": "CLGSA-JSBJ2-SUNCATCHERS-GS",
          "priceCents": 2599,
          "variantId": 51460011851943,
          "verified": true,
          "available": true
        },
        {
          "id": "youth-m",
          "label": "Youth M",
          "displayLabel": "Girls M",
          "tierId": "youth",
          "sku": "CLGSA-JSBJ2-SUNCATCHERS-GM",
          "priceCents": 2599,
          "variantId": 51460011884711,
          "verified": true,
          "available": true
        },
        {
          "id": "youth-l",
          "label": "Youth L",
          "displayLabel": "Girls L",
          "tierId": "youth",
          "sku": "CLGSA-JSBJ2-SUNCATCHERS-GL",
          "priceCents": 2599,
          "variantId": 51460011917479,
          "verified": true,
          "available": true
        },
        {
          "id": "youth-xl",
          "label": "Youth XL",
          "displayLabel": "Girls XL",
          "tierId": "youth",
          "sku": "CLGSA-JSBJ2-SUNCATCHERS-GXL",
          "priceCents": 2599,
          "variantId": 51460011950247,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-xs",
          "label": "Adult XS",
          "displayLabel": "Women XS",
          "tierId": "adult",
          "sku": "CLGSA-JSBJ2-SUNCATCHERS-WXS",
          "priceCents": 2699,
          "variantId": 51460011983015,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-s",
          "label": "Adult S",
          "displayLabel": "Women S",
          "tierId": "adult",
          "sku": "CLGSA-JSBJ2-SUNCATCHERS-WS",
          "priceCents": 2699,
          "variantId": 51460012015783,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-m",
          "label": "Adult M",
          "displayLabel": "Women M",
          "tierId": "adult",
          "sku": "CLGSA-JSBJ2-SUNCATCHERS-WM",
          "priceCents": 2699,
          "variantId": 51460012048551,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-l",
          "label": "Adult L",
          "displayLabel": "Women L",
          "tierId": "adult",
          "sku": "CLGSA-JSBJ2-SUNCATCHERS-WL",
          "priceCents": 2699,
          "variantId": 51460012081319,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-xl",
          "label": "Adult XL",
          "displayLabel": "Women XL",
          "tierId": "adult",
          "sku": "CLGSA-JSBJ2-SUNCATCHERS-WXL",
          "priceCents": 2699,
          "variantId": 51460012114087,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-2xl",
          "label": "Adult 2XL",
          "displayLabel": "Women 2XL",
          "tierId": "adult-plus",
          "sku": "CLGSA-JSBJ2-SUNCATCHERS-W2XL",
          "priceCents": 2999,
          "variantId": 51460012146855,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-3xl",
          "label": "Adult 3XL",
          "displayLabel": "Women 3XL",
          "tierId": "adult-plus",
          "sku": "CLGSA-JSBJ2-SUNCATCHERS-W3XL",
          "priceCents": 2999,
          "variantId": 51460012179623,
          "verified": true,
          "available": true
        }
      ],
      "personalization": {
        "mode": "optional-name-number",
        "rulesConfirmed": true,
        "supplierLimitsVerified": false,
        "formatsVerified": false,
        "fields": [
          {
            "id": "name",
            "label": "Name",
            "property": "Player Name",
            "maxLength": null,
            "format": "text"
          },
          {
            "id": "number",
            "label": "Number",
            "property": "Player Number",
            "maxLength": null,
            "format": "digits"
          }
        ],
        "confirmationText": "I confirm my back choice, spelling, capitalization and number. Anything omitted must not be added."
      },
      "approvedArtwork": true,
      "shopifyProduct": {
        "id": 11205603229863,
        "handle": "clgsa-player-suncatchers-jsbj2",
        "status": "DRAFT",
        "salesChannels": 0,
        "mediaCount": 1
      }
    },
    {
      "id": "player-thunderstruck",
      "name": "Thunderstruck 12U Player",
      "model": "JSBJ2",
      "accent": "#5b418e",
      "tagline": "Purple · C-TEC (proof specification; current availability unverified)",
      "images": {
        "front": "assets/player-thunderstruck.png"
      },
      "sizes": [
        {
          "id": "youth-s",
          "label": "Youth S",
          "displayLabel": "Girls S",
          "tierId": "youth",
          "sku": "CLGSA-JSBJ2-THUNDERSTRUCK-GS",
          "priceCents": 2599,
          "variantId": 51460012966055,
          "verified": true,
          "available": true
        },
        {
          "id": "youth-m",
          "label": "Youth M",
          "displayLabel": "Girls M",
          "tierId": "youth",
          "sku": "CLGSA-JSBJ2-THUNDERSTRUCK-GM",
          "priceCents": 2599,
          "variantId": 51460012998823,
          "verified": true,
          "available": true
        },
        {
          "id": "youth-l",
          "label": "Youth L",
          "displayLabel": "Girls L",
          "tierId": "youth",
          "sku": "CLGSA-JSBJ2-THUNDERSTRUCK-GL",
          "priceCents": 2599,
          "variantId": 51460013031591,
          "verified": true,
          "available": true
        },
        {
          "id": "youth-xl",
          "label": "Youth XL",
          "displayLabel": "Girls XL",
          "tierId": "youth",
          "sku": "CLGSA-JSBJ2-THUNDERSTRUCK-GXL",
          "priceCents": 2599,
          "variantId": 51460013064359,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-xs",
          "label": "Adult XS",
          "displayLabel": "Women XS",
          "tierId": "adult",
          "sku": "CLGSA-JSBJ2-THUNDERSTRUCK-WXS",
          "priceCents": 2699,
          "variantId": 51460013097127,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-s",
          "label": "Adult S",
          "displayLabel": "Women S",
          "tierId": "adult",
          "sku": "CLGSA-JSBJ2-THUNDERSTRUCK-WS",
          "priceCents": 2699,
          "variantId": 51460013129895,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-m",
          "label": "Adult M",
          "displayLabel": "Women M",
          "tierId": "adult",
          "sku": "CLGSA-JSBJ2-THUNDERSTRUCK-WM",
          "priceCents": 2699,
          "variantId": 51460013162663,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-l",
          "label": "Adult L",
          "displayLabel": "Women L",
          "tierId": "adult",
          "sku": "CLGSA-JSBJ2-THUNDERSTRUCK-WL",
          "priceCents": 2699,
          "variantId": 51460013195431,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-xl",
          "label": "Adult XL",
          "displayLabel": "Women XL",
          "tierId": "adult",
          "sku": "CLGSA-JSBJ2-THUNDERSTRUCK-WXL",
          "priceCents": 2699,
          "variantId": 51460013228199,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-2xl",
          "label": "Adult 2XL",
          "displayLabel": "Women 2XL",
          "tierId": "adult-plus",
          "sku": "CLGSA-JSBJ2-THUNDERSTRUCK-W2XL",
          "priceCents": 2999,
          "variantId": 51460013260967,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-3xl",
          "label": "Adult 3XL",
          "displayLabel": "Women 3XL",
          "tierId": "adult-plus",
          "sku": "CLGSA-JSBJ2-THUNDERSTRUCK-W3XL",
          "priceCents": 2999,
          "variantId": 51460013293735,
          "verified": true,
          "available": true
        }
      ],
      "personalization": {
        "mode": "optional-name-number",
        "rulesConfirmed": true,
        "supplierLimitsVerified": false,
        "formatsVerified": false,
        "fields": [
          {
            "id": "name",
            "label": "Name",
            "property": "Player Name",
            "maxLength": null,
            "format": "text"
          },
          {
            "id": "number",
            "label": "Number",
            "property": "Player Number",
            "maxLength": null,
            "format": "digits"
          }
        ],
        "confirmationText": "I confirm my back choice, spelling, capitalization and number. Anything omitted must not be added."
      },
      "approvedArtwork": true,
      "shopifyProduct": {
        "id": 11205603328167,
        "handle": "clgsa-player-thunderstruck-jsbj2",
        "status": "DRAFT",
        "salesChannels": 0,
        "mediaCount": 1
      }
    },
    {
      "id": "player-sandlot-sisters",
      "name": "Sandlot Sisters 6U Player",
      "model": "JSBJ2",
      "accent": "#a62059",
      "tagline": "Black · Power Stretch (proof specification; current availability unverified)",
      "images": {
        "front": "assets/player-sandlot-sisters.png"
      },
      "sizes": [
        {
          "id": "youth-s",
          "label": "Youth S",
          "displayLabel": "Girls S",
          "tierId": "youth",
          "sku": "CLGSA-JSBJ2-SANDLOT-SISTERS-GS",
          "priceCents": 2599,
          "variantId": 51460014047399,
          "verified": true,
          "available": true
        },
        {
          "id": "youth-m",
          "label": "Youth M",
          "displayLabel": "Girls M",
          "tierId": "youth",
          "sku": "CLGSA-JSBJ2-SANDLOT-SISTERS-GM",
          "priceCents": 2599,
          "variantId": 51460014080167,
          "verified": true,
          "available": true
        },
        {
          "id": "youth-l",
          "label": "Youth L",
          "displayLabel": "Girls L",
          "tierId": "youth",
          "sku": "CLGSA-JSBJ2-SANDLOT-SISTERS-GL",
          "priceCents": 2599,
          "variantId": 51460014112935,
          "verified": true,
          "available": true
        },
        {
          "id": "youth-xl",
          "label": "Youth XL",
          "displayLabel": "Girls XL",
          "tierId": "youth",
          "sku": "CLGSA-JSBJ2-SANDLOT-SISTERS-GXL",
          "priceCents": 2599,
          "variantId": 51460014145703,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-xs",
          "label": "Adult XS",
          "displayLabel": "Women XS",
          "tierId": "adult",
          "sku": "CLGSA-JSBJ2-SANDLOT-SISTERS-WXS",
          "priceCents": 2699,
          "variantId": 51460014178471,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-s",
          "label": "Adult S",
          "displayLabel": "Women S",
          "tierId": "adult",
          "sku": "CLGSA-JSBJ2-SANDLOT-SISTERS-WS",
          "priceCents": 2699,
          "variantId": 51460014211239,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-m",
          "label": "Adult M",
          "displayLabel": "Women M",
          "tierId": "adult",
          "sku": "CLGSA-JSBJ2-SANDLOT-SISTERS-WM",
          "priceCents": 2699,
          "variantId": 51460014244007,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-l",
          "label": "Adult L",
          "displayLabel": "Women L",
          "tierId": "adult",
          "sku": "CLGSA-JSBJ2-SANDLOT-SISTERS-WL",
          "priceCents": 2699,
          "variantId": 51460014276775,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-xl",
          "label": "Adult XL",
          "displayLabel": "Women XL",
          "tierId": "adult",
          "sku": "CLGSA-JSBJ2-SANDLOT-SISTERS-WXL",
          "priceCents": 2699,
          "variantId": 51460014309543,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-2xl",
          "label": "Adult 2XL",
          "displayLabel": "Women 2XL",
          "tierId": "adult-plus",
          "sku": "CLGSA-JSBJ2-SANDLOT-SISTERS-W2XL",
          "priceCents": 2999,
          "variantId": 51460014342311,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-3xl",
          "label": "Adult 3XL",
          "displayLabel": "Women 3XL",
          "tierId": "adult-plus",
          "sku": "CLGSA-JSBJ2-SANDLOT-SISTERS-W3XL",
          "priceCents": 2999,
          "variantId": 51460014375079,
          "verified": true,
          "available": true
        }
      ],
      "personalization": {
        "mode": "optional-name-number",
        "rulesConfirmed": true,
        "supplierLimitsVerified": false,
        "formatsVerified": false,
        "fields": [
          {
            "id": "name",
            "label": "Name",
            "property": "Player Name",
            "maxLength": null,
            "format": "text"
          },
          {
            "id": "number",
            "label": "Number",
            "property": "Player Number",
            "maxLength": null,
            "format": "digits"
          }
        ],
        "confirmationText": "I confirm my back choice, spelling, capitalization and number. Anything omitted must not be added."
      },
      "approvedArtwork": true,
      "shopifyProduct": {
        "id": 11205603459239,
        "handle": "clgsa-player-sandlot-sisters-jsbj2",
        "status": "DRAFT",
        "salesChannels": 0,
        "mediaCount": 1
      }
    },
    {
      "id": "player-valkyries",
      "name": "Valkyries 8U Player",
      "model": "JSBJ2",
      "accent": "#34758b",
      "tagline": "Black · Z-CLOTH (proof specification; current availability unverified)",
      "images": {
        "front": "assets/player-valkyries.png"
      },
      "sizes": [
        {
          "id": "youth-s",
          "label": "Youth S",
          "displayLabel": "Girls S",
          "tierId": "youth",
          "sku": "CLGSA-JSBJ2-VALKYRIES-GS",
          "priceCents": 2599,
          "variantId": 51460015030439,
          "verified": true,
          "available": true
        },
        {
          "id": "youth-m",
          "label": "Youth M",
          "displayLabel": "Girls M",
          "tierId": "youth",
          "sku": "CLGSA-JSBJ2-VALKYRIES-GM",
          "priceCents": 2599,
          "variantId": 51460015063207,
          "verified": true,
          "available": true
        },
        {
          "id": "youth-l",
          "label": "Youth L",
          "displayLabel": "Girls L",
          "tierId": "youth",
          "sku": "CLGSA-JSBJ2-VALKYRIES-GL",
          "priceCents": 2599,
          "variantId": 51460015095975,
          "verified": true,
          "available": true
        },
        {
          "id": "youth-xl",
          "label": "Youth XL",
          "displayLabel": "Girls XL",
          "tierId": "youth",
          "sku": "CLGSA-JSBJ2-VALKYRIES-GXL",
          "priceCents": 2599,
          "variantId": 51460015128743,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-xs",
          "label": "Adult XS",
          "displayLabel": "Women XS",
          "tierId": "adult",
          "sku": "CLGSA-JSBJ2-VALKYRIES-WXS",
          "priceCents": 2699,
          "variantId": 51460015161511,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-s",
          "label": "Adult S",
          "displayLabel": "Women S",
          "tierId": "adult",
          "sku": "CLGSA-JSBJ2-VALKYRIES-WS",
          "priceCents": 2699,
          "variantId": 51460015194279,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-m",
          "label": "Adult M",
          "displayLabel": "Women M",
          "tierId": "adult",
          "sku": "CLGSA-JSBJ2-VALKYRIES-WM",
          "priceCents": 2699,
          "variantId": 51460015227047,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-l",
          "label": "Adult L",
          "displayLabel": "Women L",
          "tierId": "adult",
          "sku": "CLGSA-JSBJ2-VALKYRIES-WL",
          "priceCents": 2699,
          "variantId": 51460015259815,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-xl",
          "label": "Adult XL",
          "displayLabel": "Women XL",
          "tierId": "adult",
          "sku": "CLGSA-JSBJ2-VALKYRIES-WXL",
          "priceCents": 2699,
          "variantId": 51460015292583,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-2xl",
          "label": "Adult 2XL",
          "displayLabel": "Women 2XL",
          "tierId": "adult-plus",
          "sku": "CLGSA-JSBJ2-VALKYRIES-W2XL",
          "priceCents": 2999,
          "variantId": 51460015325351,
          "verified": true,
          "available": true
        },
        {
          "id": "adult-3xl",
          "label": "Adult 3XL",
          "displayLabel": "Women 3XL",
          "tierId": "adult-plus",
          "sku": "CLGSA-JSBJ2-VALKYRIES-W3XL",
          "priceCents": 2999,
          "variantId": 51460015358119,
          "verified": true,
          "available": true
        }
      ],
      "personalization": {
        "mode": "optional-name-number",
        "rulesConfirmed": true,
        "supplierLimitsVerified": false,
        "formatsVerified": false,
        "fields": [
          {
            "id": "name",
            "label": "Name",
            "property": "Player Name",
            "maxLength": null,
            "format": "text"
          },
          {
            "id": "number",
            "label": "Number",
            "property": "Player Number",
            "maxLength": null,
            "format": "digits"
          }
        ],
        "confirmationText": "I confirm my back choice, spelling, capitalization and number. Anything omitted must not be added."
      },
      "approvedArtwork": true,
      "shopifyProduct": {
        "id": 11205603557543,
        "handle": "clgsa-player-valkyries-jsbj2",
        "status": "DRAFT",
        "salesChannels": 0,
        "mediaCount": 1
      }
    }
  ],
  "production": {
    "constraintsVerified": false,
    "handoutDate": null
  },
  "readiness": {
    "activationApproved": true,
    "paymentVerified": false,
    "backendCutoffVerified": false,
    "deliveryVerified": true,
    "notificationVerified": false
  },
  "round": {
    "id": "clgsa-20261003",
    "sourceMessages": [
      "53386",
      "53389",
      "53440",
      "53443",
      "53448",
      "53519"
    ],
    "authorId": "8332026845",
    "activation": {
      "roundId": "clgsa-20261003",
      "manifestSHA256": "32414a5e8611a3181df18661fb45cc392727f655d36a6e75a27a8e444f17155b",
      "approvalReceipt": "f863d204a3d1872878cafa9859376739"
    },
    "acceptance": {
      "tx": "3310c842-98c4-4679-8a71-a644012530b2",
      "manifest": "32414a5e8611a3181df18661fb45cc392727f655d36a6e75a27a8e444f17155b",
      "at": "2026-10-06T00:59:49.922Z",
      "evidenceRef": "independent-evidence-ref-3310c842.json",
      "catalog": {
        "tx": "3310c842-98c4-4679-8a71-a644012530b2",
        "manifest": "32414a5e8611a3181df18661fb45cc392727f655d36a6e75a27a8e444f17155b",
        "at": "2026-10-06T00:59:49.922Z",
        "apiVersion": "2025-10",
        "productIds": [
          11171891904679,
          11171892101287,
          11171891970215,
          11171892068519,
          11171892002983,
          11205603066023,
          11205603229863,
          11205603328167,
          11205603459239,
          11205603557543
        ],
        "allCurrentUnlisted": true,
        "documentedUnlistedExclusion": true,
        "sourceUi": {
          "url": "https://admin.shopify.com/store/f0fzz3-qn/apps/agentic",
          "draftBaselineCount": 15,
          "currentCount": 15,
          "evidenceFile": "review-post-source.png",
          "evidenceSHA256": "caf1b002a1443c97a9dd1351f28cf9a9c79f12e97175a74cc34083e67ecd1f0f"
        },
        "search": {
          "query": "CLGSA",
          "targetMatches": 0,
          "evidenceFile": "review-post-search.png",
          "evidenceSHA256": "8ea5a59e6f617c2e268af9d6a6171ab77ec094c25a7414f36f5e15a025e1999f"
        }
      },
      "channelScope": true,
      "agenticExclusion": true,
      "delivery": true,
      "cart": true,
      "tax": true,
      "parentCommercial": true,
      "fourModes": true,
      "leadingZero007": true,
      "mixedCartPreserved": true,
      "testCartRestored": true,
      "noPaymentOrOrder": true,
      "noDeliveryPromise": true,
      "liveMedia": true,
      "publicRoutes": true,
      "pickupTransfer": true,
      "roundId": "clgsa-20261003",
      "manifestSHA256": "32414a5e8611a3181df18661fb45cc392727f655d36a6e75a27a8e444f17155b"
    }
  },
  "playerSizeGuide": {
    "approved": true,
    "sourceUrl": "https://online.flippingbook.com/view/1002446/159/",
    "customerText": "JSBJ2 regular length: Girls S–XL; Women XS–3XL. Size range is not stock availability. JSBJ2 body measurements unverified; JMSV1 measurements do not apply.",
    "bodyMeasurements": {}
  },
  "playerTiers": [
    {
      "id": "youth",
      "label": "Youth",
      "priceCents": 2599
    },
    {
      "id": "adult",
      "label": "Adult",
      "priceCents": 2699
    },
    {
      "id": "adult-plus",
      "label": "Adult 2XL+",
      "priceCents": 2999
    }
  ]
};
